import classNames from 'classnames';
import type React from 'react';
import { forwardRef, useMemo } from 'react';
import { NavbarButton } from './NavbarButton';
import { NavbarButtonGroup } from './NavbarButtonGroup';
import { NavbarCenterControls } from './NavbarCenterControls';
import { NavbarContext } from './NavbarContext';
import { NavbarIcon } from './NavbarIcon';
import { NavbarNavigation } from './NavbarNavigation';
import { NavbarPageDetails } from './NavbarPageDetails';
import { NavbarSeparator } from './NavbarSeparator';
import { NavbarToggleButton } from './NavbarToggleButton';
import type { NavbarTheme } from './types';

export interface NavbarProps {
  theme?: NavbarTheme;
  children?: React.ReactNode;
}

const Navbar = forwardRef<HTMLDivElement, NavbarProps>(
  ({ theme = 'light', children }, ref) => {
    const navbarContext = useMemo(
      () => ({
        theme,
      }),
      [theme]
    );

    return (
      <NavbarContext.Provider value={navbarContext}>
        <nav
          className={classNames(
            'relative h-ds-15 flex items-center flex-shrink-0 w-full z-200 pr-5 border-b box-border',
            theme === 'dark'
              ? 'bg-ds-natural-600 border-ds-natural-500'
              : 'bg-ds-accent3-100 border-ds-natural-150'
          )}
          ref={ref}
        >
          {children}
        </nav>
      </NavbarContext.Provider>
    );
  }
);

const NavbarNamespace = Object.assign(Navbar, {
  PageDetails: NavbarPageDetails,
  Navigation: NavbarNavigation,
  Icon: NavbarIcon,
  Button: NavbarButton,
  ToggleButton: NavbarToggleButton,
  ButtonGroup: NavbarButtonGroup,
  CenterControls: NavbarCenterControls,
  Separator: NavbarSeparator,
});

export { NavbarNamespace as Navbar };
